import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  noteContainer: {
    padding: "16px",
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
  },
  buttonContainer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "flex-end",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px", // Space between label and textarea
  },
  textarea: {
    padding: "8px",
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    fontSize: theme.fontSizes.md,
    resize: "vertical", // Allow vertical resizing only
    "&:focus": {
      outline: `2px solid ${theme.colors.blue[5]}`,
      borderColor: theme.colors.blue[5],
    },
  },
}));